import { Box, Button, Typography } from '@material-ui/core';
import { useDispatch } from 'react-redux';
import { setModalStatus } from 'redux/slices/modal.slice';
import { useHistory } from 'react-router-dom';

const NoOfficesWarningPanel = () => {
  const dispatch = useDispatch();

  const { replace } = useHistory();

  const onAcceptHandler = () => {
    dispatch(
      setModalStatus({
        name: 'NO_OFFICES_WARNING',
        isActive: false,
      }),
    );
  };

  const onRedirectHandler = () => {
    onAcceptHandler();
    setTimeout(() => {
      replace('/settings/profile/offices');
    }, 1000);
  };

  return (
    <Box textAlign="center">
      <Typography variant="h6">
        No tienes consultorios disponibles para agendar una cita.
      </Typography>
      <Typography variant="body2" style={{ paddingTop: 8, paddingBottom: 8 }}>
        Para poder agendar una cita, es necesario tener algun consultorio
        disponible.
      </Typography>
      <Box display="flex" alignItems="center" justifyContent="space-evenly">
        <Button variant="outlined" onClick={onAcceptHandler} color="primary">
          Aceptar
        </Button>
        <Button variant="contained" onClick={onRedirectHandler} color="primary">
          Ir a mis consultorios
        </Button>
      </Box>
    </Box>
  );
};

export default NoOfficesWarningPanel;
